import { useState } from 'react';
import type { Project } from '../../types';
import AdminDrawer from '../AdminDrawer';

const projects: Project[] = [
  { id: 'p1',  name: 'Nový web Pet Shop',        client: 'Bratislava Pet Shop',  clientInitials: 'BS', clientColor: 'bg-emerald-600', status: 'running', phase: 'Vývoj',            progress: 65,  deadline: '30.4.2025', team: ['TN', 'MK']       },
  { id: 'p2',  name: 'Google Ads Q2',             client: 'Bratislava Pet Shop',  clientInitials: 'BS', clientColor: 'bg-emerald-600', status: 'running', phase: 'Optimalizácia',    progress: 40,  deadline: '30.6.2025', team: ['PH']             },
  { id: 'p3',  name: 'SEO & Content stratégia',   client: 'TechFlow s.r.o.',      clientInitials: 'TF', clientColor: 'bg-sky-600',     status: 'review',  phase: 'Review klientom',  progress: 90,  deadline: '5.4.2025',  team: ['MK', 'JS']      },
  { id: 'p4',  name: 'Facebook Ads kampaň',       client: 'TechFlow s.r.o.',      clientInitials: 'TF', clientColor: 'bg-sky-600',     status: 'running', phase: 'Spustenie',        progress: 55,  deadline: '15.4.2025', team: ['PH', 'TN']      },
  { id: 'p5',  name: 'Scale – Full stack mktg',   client: 'TechFlow s.r.o.',      clientInitials: 'TF', clientColor: 'bg-sky-600',     status: 'running', phase: 'Analýza',          progress: 20,  deadline: '30.6.2025', team: ['MK', 'PH', 'TN']},
  { id: 'p6',  name: 'E-shop redesign',           client: 'VitaBenefit s.r.o.',   clientInitials: 'VB', clientColor: 'bg-violet-600',  status: 'review',  phase: 'Dizajn review',    progress: 80,  deadline: '10.4.2025', team: ['TN']            },
  { id: 'p7',  name: 'Instagramová komunikácia',  client: 'Petra K. – Kozmetika', clientInitials: 'PK', clientColor: 'bg-pink-600',    status: 'running', phase: 'Content',          progress: 50,  deadline: '1.5.2025',  team: ['JS']            },
  { id: 'p8',  name: 'Web + SEO',                 client: 'MotoLux SK',           clientInitials: 'ML', clientColor: 'bg-orange-600',  status: 'running', phase: 'Implementácia',    progress: 30,  deadline: '20.5.2025', team: ['TN', 'MK']      },
  { id: 'p9',  name: 'Branding & web',            client: 'DW Atelié',            clientInitials: 'DW', clientColor: 'bg-rose-600',    status: 'done',    phase: 'Dokončené',        progress: 100, deadline: '1.3.2025',  team: ['TN']            },
  { id: 'p10', name: 'PPC kampane',               client: 'FreshAir s.r.o.',      clientInitials: 'FA', clientColor: 'bg-teal-600',    status: 'paused',  phase: 'Pozastavené',      progress: 45,  deadline: '-',         team: ['PH']            },
];

const milestones: Record<string, { label: string; done: boolean; date: string }[]> = {
  p1:  [{ label: 'Kickoff & briefing', done: true, date: '10.1.2025' }, { label: 'Wireframy', done: true, date: '28.1.2025' }, { label: 'Dizajn', done: true, date: '20.2.2025' }, { label: 'Vývoj', done: false, date: '15.4.2025' }, { label: 'Testovanie & live', done: false, date: '30.4.2025' }],
  p2:  [{ label: 'Nastavenie kampaní', done: true, date: '1.4.2025' }, { label: 'Prvá optimalizácia', done: false, date: '15.4.2025' }, { label: 'Mesačný report', done: false, date: '30.6.2025' }],
  p3:  [{ label: 'Audit webu', done: true, date: '1.3.2025' }, { label: 'Keyword research', done: true, date: '10.3.2025' }, { label: 'Obsahová stratégia', done: true, date: '25.3.2025' }, { label: 'Review klientom', done: false, date: '5.4.2025' }],
  p4:  [{ label: 'Kreatívy & copywriting', done: true, date: '20.3.2025' }, { label: 'Nastavenie kampaní', done: true, date: '1.4.2025' }, { label: 'Spustenie', done: false, date: '15.4.2025' }],
  p5:  [{ label: 'Discovery & analýza', done: false, date: '15.4.2025' }, { label: 'Stratégia', done: false, date: '1.5.2025' }, { label: 'Implementácia', done: false, date: '30.6.2025' }],
  p6:  [{ label: 'UX audit', done: true, date: '5.3.2025' }, { label: 'Wireframy', done: true, date: '15.3.2025' }, { label: 'Dizajn', done: true, date: '1.4.2025' }, { label: 'Review', done: false, date: '10.4.2025' }],
  p7:  [{ label: 'Obsahový plán', done: true, date: '1.3.2025' }, { label: 'Prvé posty', done: true, date: '15.3.2025' }, { label: 'Optimalizácia', done: false, date: '1.5.2025' }],
  p8:  [{ label: 'Briefing & research', done: true, date: '15.3.2025' }, { label: 'Dizajn', done: false, date: '15.4.2025' }, { label: 'Vývoj', done: false, date: '10.5.2025' }, { label: 'Live', done: false, date: '20.5.2025' }],
  p9:  [{ label: 'Branding', done: true, date: '1.1.2025' }, { label: 'Web dizajn', done: true, date: '1.2.2025' }, { label: 'Vývoj & live', done: true, date: '1.3.2025' }],
  p10: [{ label: 'Nastavenie účtov', done: true, date: '1.9.2024' }, { label: 'Kampane', done: true, date: '15.9.2024' }, { label: 'Pozastavené', done: false, date: '-' }],
};

const projectNotes: Record<string, string> = {
  p1:  'Klient dodal texty pre domovskú stránku. Čaká sa na fotografie produktov pred finálnym vývojom.',
  p2:  'ROAS za marcový týždeň je 380 %. Optimalizujeme bidding na produktové kategórie.',
  p3:  'Stratégia odoslaná klientovi na schválenie 28.3. Čaká sa na spätnú väzbu.',
  p4:  'Kreatívy schválené. Plánované spustenie 15.4. po finálnom testovaní pixelu.',
  p5:  'Úvodný discovery call prebehol 25.3. Analýza konkurencie prebieha.',
  p6:  'Klient má 48h na schválenie dizajnu. Ak bude OK, ide do vývoja 12.4.',
  p7:  'Engagement rate rastie. Priemerný dosah +42 % oproti predchádzajúcemu mesiacu.',
  p8:  'SEO štruktúra webu definovaná. Vývoj začína 5.4.',
  p9:  'Projekt dokončený a odovzdaný. Klient veľmi spokojný, plánuje Growth balíček.',
  p10: 'Pozastavené na žiadosť klienta. Čaká sa na rozhodnutie o pokračovaní.',
};

const statusStyle: Record<Project['status'], string> = {
  running: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  review:  'bg-amber-500/10 text-amber-400 border-amber-500/20',
  done:    'bg-zinc-700/40 text-zinc-500 border-zinc-600/30',
  paused:  'bg-red-500/10 text-red-400 border-red-500/20',
};
const statusLabel: Record<Project['status'], string> = {
  running: 'Prebieha', review: 'V review', done: 'Hotovo', paused: 'Pozastavený',
};
const teamColors = ['bg-sky-600', 'bg-violet-600', 'bg-teal-600', 'bg-pink-600'];
const teamNames: Record<string, string> = { TN: 'Tomáš N.', MK: 'Marek K.', PH: 'Patrik H.', JS: 'Jana S.' };

export default function AdminProjekty() {
  const [filter, setFilter] = useState<'all' | Project['status']>('all');
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<Project | null>(null);

  const filtered = projects.filter((p) => {
    const q = search.toLowerCase();
    return (p.name.toLowerCase().includes(q) || p.client.toLowerCase().includes(q))
      && (filter === 'all' || p.status === filter);
  });

  const open = (p: Project) => setSelected(p);
  const close = () => setSelected(null);

  return (
    <div className="h-full overflow-y-auto p-6">
      {/* Filters */}
      <div className="flex items-center gap-3 mb-5">
        <div className="flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-xl px-3 py-2 flex-1 max-w-xs">
          <i className="ri-search-line text-zinc-500 text-sm" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Hľadať projekt..." className="bg-transparent text-zinc-300 text-sm placeholder:text-zinc-600 outline-none flex-1" />
        </div>
        {(['all', 'running', 'review', 'paused', 'done'] as const).map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`px-3.5 py-2 rounded-xl text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${filter === s ? 'bg-orange-500/10 border border-orange-500/20 text-orange-400' : 'bg-zinc-900 border border-zinc-800 text-zinc-500 hover:text-zinc-300'}`}>
            {s === 'all' ? 'Všetky' : statusLabel[s]}
          </button>
        ))}
        <div className="flex-1" />
        <button className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-xs font-semibold px-4 py-2 rounded-xl transition-all cursor-pointer whitespace-nowrap">
          <i className="ri-folder-add-line text-sm" /> Nový projekt
        </button>
      </div>

      {/* Cards grid */}
      <div className="grid grid-cols-2 gap-4">
        {filtered.map((p) => (
          <div key={p.id} onClick={() => open(p)} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4 hover:border-orange-500/30 hover:bg-zinc-800/50 transition-all cursor-pointer group">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2.5">
                <div className={`w-8 h-8 rounded-xl ${p.clientColor} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-white text-xs font-bold">{p.clientInitials}</span>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold leading-tight group-hover:text-orange-300 transition-colors">{p.name}</p>
                  <p className="text-zinc-600 text-xs mt-0.5">{p.client}</p>
                </div>
              </div>
              <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full border flex-shrink-0 ${statusStyle[p.status]}`}>{statusLabel[p.status]}</span>
            </div>
            <div className="mb-3">
              <div className="flex items-center justify-between mb-1">
                <span className="text-zinc-600 text-[10px]">{p.phase}</span>
                <span className="text-zinc-400 text-[10px] font-semibold">{p.progress} %</span>
              </div>
              <div className="w-full bg-zinc-800 rounded-full h-1.5">
                <div className={`h-1.5 rounded-full transition-all ${p.progress === 100 ? 'bg-emerald-500' : 'bg-orange-500'}`} style={{ width: `${p.progress}%` }} />
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1">
                {p.team.map((t, i) => (
                  <div key={t} className={`w-6 h-6 rounded-full ${teamColors[i % teamColors.length]} flex items-center justify-center border-2 border-zinc-900 -ml-1.5 first:ml-0`}>
                    <span className="text-white text-[9px] font-bold">{t}</span>
                  </div>
                ))}
              </div>
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-1 text-zinc-600 text-[10px]">
                  <i className="ri-calendar-line text-xs" /><span>{p.deadline}</span>
                </div>
                <div className="w-6 h-6 flex items-center justify-center rounded-lg bg-zinc-800 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-line text-zinc-400 text-xs" />
                </div>
              </div>
            </div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="col-span-2 text-center py-16">
            <i className="ri-folder-search-line text-zinc-700 text-3xl" />
            <p className="text-zinc-600 text-sm mt-2">Žiadne projekty nevyhovujú filtru</p>
          </div>
        )}
      </div>

      {/* Project detail drawer */}
      {selected && (
        <AdminDrawer
          open={!!selected}
          onClose={close}
          title={selected.name}
          subtitle={selected.client}
          icon="ri-folder-3-line"
          iconBg={selected.clientColor}
        >
          <div className="p-5 space-y-5">
            {/* Status + progress */}
            <div className="bg-zinc-800/50 rounded-2xl p-4 space-y-3">
              <div className="flex items-center justify-between">
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${statusStyle[selected.status]}`}>{statusLabel[selected.status]}</span>
                <span className="text-zinc-400 text-xs font-bold">{selected.progress} %</span>
              </div>
              <div>
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-zinc-500 text-xs">Aktuálna fáza: <span className="text-zinc-300 font-medium">{selected.phase}</span></span>
                  <span className="text-zinc-600 text-xs">Deadline: <span className="text-zinc-400">{selected.deadline}</span></span>
                </div>
                <div className="w-full bg-zinc-700 rounded-full h-2">
                  <div className={`h-2 rounded-full ${selected.progress === 100 ? 'bg-emerald-500' : 'bg-orange-500'}`} style={{ width: `${selected.progress}%` }} />
                </div>
              </div>
            </div>

            {/* Team */}
            <div>
              <p className="text-zinc-600 text-[10px] font-bold uppercase tracking-widest mb-2.5">Tím</p>
              <div className="flex flex-col gap-2">
                {selected.team.map((t, i) => (
                  <div key={t} className="flex items-center gap-3 bg-zinc-800/40 rounded-xl p-2.5">
                    <div className={`w-8 h-8 rounded-lg ${teamColors[i % teamColors.length]} flex items-center justify-center flex-shrink-0`}>
                      <span className="text-white text-xs font-bold">{t}</span>
                    </div>
                    <div>
                      <p className="text-zinc-200 text-xs font-medium">{teamNames[t] ?? t}</p>
                      <p className="text-zinc-600 text-[10px]">Riešiteľ projektu</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Milestones */}
            <div>
              <p className="text-zinc-600 text-[10px] font-bold uppercase tracking-widest mb-3">Míľniky</p>
              <div className="space-y-0">
                {(milestones[selected.id] ?? []).map((m, idx, arr) => (
                  <div key={m.label} className="relative flex items-start gap-3 pb-4 last:pb-0">
                    {idx < arr.length - 1 && (
                      <div className={`absolute left-[13px] top-6 bottom-0 w-0.5 ${m.done ? 'bg-orange-500/40' : 'bg-zinc-800'}`} />
                    )}
                    <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 z-10 border-2 ${m.done ? 'bg-orange-500 border-orange-500' : 'bg-zinc-900 border-zinc-700'}`}>
                      {m.done
                        ? <i className="ri-check-line text-white text-xs" />
                        : <span className="w-2 h-2 bg-zinc-700 rounded-full" />
                      }
                    </div>
                    <div className="pt-1">
                      <p className={`text-xs font-medium ${m.done ? 'text-zinc-300' : 'text-zinc-500'}`}>{m.label}</p>
                      <p className="text-zinc-700 text-[10px] mt-0.5">{m.date}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Notes */}
            <div>
              <p className="text-zinc-600 text-[10px] font-bold uppercase tracking-widest mb-2">Poznámky</p>
              <div className="bg-zinc-800/40 rounded-xl p-3">
                <p className="text-zinc-400 text-xs leading-relaxed">{projectNotes[selected.id] ?? 'Žiadne poznámky.'}</p>
              </div>
            </div>

            {/* Actions */}
            <div className="flex flex-col gap-2 pt-1">
              <button className="w-full flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-pencil-line" /> Upraviť projekt
              </button>
              <div className="grid grid-cols-2 gap-2">
                <button className="flex items-center justify-center gap-2 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 text-xs font-semibold py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap">
                  <i className="ri-message-3-line" /> Napísať klientovi
                </button>
                <button className="flex items-center justify-center gap-2 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 text-xs font-semibold py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap">
                  <i className="ri-share-line" /> Zdieľať s klientom
                </button>
              </div>
            </div>
          </div>
        </AdminDrawer>
      )}
    </div>
  );
}
